module.exports = __webpack_public_path__ + "static/trees-1ee7cd3439338470af58edbb363846c6.jpg";